<template>
  <div class="container-body">
    <highcharts
      ref="highChart"
      :style="{height: '100%'}"
      :options="props.highChartOptions"
      :constructor-type="props.highChartOptions.chart!.type === 'column' ? 'chart' : 'stockChart'"
    />
  </div>
</template>
<script setup lang="ts">
import { Options } from 'highcharts'
import { onMounted, ref } from 'vue'

export type IProps = {
  highChartOptions: Options
}
const props = defineProps<IProps>()
const emit = defineEmits([ 'get-chart-reference' ])



const highChart = ref()

onMounted(() => {
  emit('get-chart-reference', highChart.value)
})

</script>
<style scoped lang="scss">
.container-body {
  flex-grow: 1;

  :deep(.highcharts-range-selector-group) {
    display: none;
  }
  :deep(select) {
    display: none;
  }
}
</style>